var $ = require("jquery");

export default function () {

    const radioButtons = $('input[type=radio]');

    if (!(radioButtons.size() === 0)) {
        radioButtons.each(function () {
            if ($(this).prop('disabled')) {
                if ($(this).parent().parent('.btn-group-toggle').length != 0) {
                    $(this).parent().addClass('disabled');
                }
            }
        })
    }
};


// WEBPACK FOOTER //
// ./App/components/radioButtonDisableShareWithLabel.js